import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const UpArrow = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 29V5.59998L24.262 13.663C24.45 13.863 24.712 14.001 25 14.001C25.55 14.001 26 13.551 26 13.001C26 12.739 25.9 12.513 25.738 12.339L16.738 2.33898C16.55 2.12698 16.276 2.01398 16 2.01398C15.724 2.01398 15.45 2.13898 15.262 2.33898L6.26199 12.339C6.09999 12.514 5.99899 12.751 5.99899 13.001C5.99899 13.551 6.44899 14.001 6.99899 14.001C7.29899 14.001 7.56199 13.876 7.73599 13.663L14.999 5.59998V29C14.999 29.55 15.449 30 15.999 30C16.549 30 16.999 29.55 16.999 29H17Z" />
	</svg>
);

export default UpArrow;
